import {string, record, nullable, Parser, date} from '@freckle/parser'

type DemoDistrictT = {
  owner: string
  requestedAt?: Date
  creationStartedAt?: Date
  createdAt?: Date
  creationFailedReason?: string
  loginPassword?: string
}

const demoDistrictParser = record({
  owner: string(),
  requestedAt: nullable(date()),
  creationStartedAt: nullable(date()),
  createdAt: nullable(date()),
  creationFailedReason: nullable(string()),
  loginPassword: nullable(string())
})

export function parseDemoDistrict(response: unknown): DemoDistrictT {
  return Parser.run(response, demoDistrictParser) as DemoDistrictT
}

export type {DemoDistrictT}
